import { rgba } from 'polished';
import { PropsWithChildren, ReactNode, useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

import { PopoverPortal } from './PopoverProvider';

const PopoverContainer = styled.div`
	background: white;
	border-radius: 4px;
	filter: drop-shadow(0 2px 4px ${rgba(tokens.border.subtle, 0.5)})
		drop-shadow(0 0px 1px ${rgba(tokens.border.subtle, 1.0)});
`;

const PopoverArrow = styled.div<{ direction: 'north' | 'south' }>`
	position: absolute;
	width: 8px;
	height: 8px;
	background: white;
	left: 50%;

	${(props) =>
		props.direction === 'north'
			? `
		bottom: 0;
		transform: translate(-50%, 50%) rotate(45deg);
	`
			: `
		top: 0;
		transform: translate(-50%, -50%) rotate(45deg);
	`}
`;

const PopoverContents = styled(Box)`
	position: relative;
	width: 300px;
`;

export default function PopoverTarget(
	props: PropsWithChildren<{
		enabled?: boolean;
		style?: any;
		visible?: boolean;
		content: ReactNode;
	}>,
) {
	const [hoverInside, setHoverInside] = useState(false);
	const [hoverOutside, setHoverOutside] = useState(false);

	const hover = hoverInside || hoverOutside;
	const visible = props.visible ?? hover;

	return (
		<Box style={{ position: 'relative', ...props.style }}>
			{props.enabled !== false && visible && (
				<PopoverPortal>
					{(direction) => (
						<PopoverContainer
							onMouseMove={() => setHoverOutside(true)}
							onMouseLeave={() => setHoverOutside(false)}
						>
							<PopoverContents>{props.content}</PopoverContents>
							<PopoverArrow direction={direction} />
						</PopoverContainer>
					)}
				</PopoverPortal>
			)}
			<Box
				onMouseMove={() => setHoverInside(true)}
				onMouseLeave={() => setTimeout(() => setHoverInside(false))}
			>
				{props.children}
			</Box>
		</Box>
	);
}
